/**
 * Display ONLY the applicant's explicitly recorded Enhanced DBS declaration.
 *
 * A declared conviction, an Update Service subscription, or manager review
 * must never stand in for the applicant's consent. This helper is presentation
 * only: it cannot grant permission or approve a DBS check.
 */
export function getEnhancedDbsConsentDisplay(consent) {
  if (consent === true) {
    return {
      status: 'given',
      label: 'Consent given',
      description: 'Enhanced DBS check consent recorded in the applicant declaration.',
      className: 'text-emerald-800',
      panelClassName: 'bg-emerald-50 border-emerald-200',
    };
  }

  if (consent === false) {
    return {
      status: 'not_given',
      label: 'Not given',
      description: 'The recorded declaration does not give Enhanced DBS check consent.',
      className: 'text-red-800',
      panelClassName: 'bg-red-50 border-red-200',
    };
  }

  return {
    status: 'unavailable',
    label: 'Not recorded',
    description: 'No explicit applicant Enhanced DBS consent answer is available in this summary. Check the original declaration.',
    className: 'text-slate-600',
    panelClassName: 'bg-slate-50 border-slate-200',
  };
}
